import { createMemoryHistory } from 'history';

export const history = createMemoryHistory();

export default history;
